import type { ReactNode } from 'react';
import { ALL_MAPS } from '../../config/mapPool';

export function proMapName(mapName?: string | null) {
  return ALL_MAPS.find(map => map.id === mapName?.toLowerCase().replace(/^de_/, '').replace(/\s+/g, ''));
}

export function ProMapArtwork({ mapName, mapNumber, team1Name, team2Name, team1Score, team2Score, children }: {
  mapName?: string | null;
  mapNumber?: number | null;
  team1Name: string;
  team2Name: string;
  team1Score?: number | null;
  team2Score?: number | null;
  children?: ReactNode;
}) {
  const map = proMapName(mapName);
  const hasScore = team1Score != null && team2Score != null;
  return <div className="recent-pro-map-art" style={map ? { backgroundImage: `url("${map.image}")` } : undefined}>
    <div className="recent-pro-map-content">
      <div className="recent-pro-map-title"><strong>{map?.name || mapName || 'TBA'}</strong>{mapNumber != null && <span>MAP {mapNumber}</span>}</div>
      {hasScore ? <div className="recent-pro-map-score" aria-label={`${team1Name} ${team1Score} to ${team2Score} ${team2Name}`} title={`${team1Name} — ${team2Name}`}>
        <span className={team1Score > team2Score ? 'is-winner' : ''}>{team1Score}</span><span className="recent-pro-score-divider">:</span>
        <span className={team2Score > team1Score ? 'is-winner' : ''}>{team2Score}</span>
      </div> : <span className="recent-pro-score-missing">Score unavailable</span>}
      {children}
    </div>
  </div>;
}
